import { translate } from 'loankeeper-common/helpers'

export default (key: string) => translate(`frm_auth_loanevent_history-${key}`)
export const translateLKMessage = (key: string) => translate(`LKMESSAGE-${key}`)
